<template>
  <div class="form-group">
    <label v-if="title">
      <span class="title">{{ title }} </span>
      <span class="required" v-if="required">*</span>
      <Tip :field="field" :formName="formName" />
    </label>
    <div class="inner-addon right-addon">
      <i v-if="notifications.length > 0 && formDirty" class="required glyphicon fas fa-exclamation-triangle"></i>
      <date-picker lang="pt-br" :disabled="disabled" :range="range" @confirm="executeConfirm" @change="executeConfirm"
        @clear="close" :confirm="confirm" :confirm-text="confirmText" :format="format" value-type="format"
        :append-to-body="!!appendToBody"
        :popup-style="popupStyle"
        :time-picker-options="{
        start: '07:00',
        step: '00:30',
        end: '23:30',
        format: 'HH:mm',
      }" width="100%" :placeholder="placeholder" :type="type" v-model="valueLocal"
        :class="{ 'is-invalid': notifications.length > 0 && formDirty }"></date-picker>
    </div>

    <div v-if="formDirty">
      <div v-for="message in notifications" :key="message">
        <span class="invalid">{{ message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Tip from "../shared/Tip.vue";
import DatePicker from "vue2-datepicker";

import { mapState, mapMutations, mapGetters } from "vuex";

export default {
  components: { Tip, DatePicker },
  name: "Data",
  mixins: [],
  props: [
    "title",
    "field",
    "fieldTarget",
    "placeholder",
    "formName",
    "required",
    "disabled",
    "format",
    "type",
    "value",
    "range",
    "confirm",
    "confirmText",
    "markFormDirty",
    "appendToBody",
    "popupStyle",
  ],
  data() {
    return {
      notifications: [],
      formDirty: false,
      valueLocal: "",
      markFormDirtyLocal: false,
    };
  },
  created() {
    this.validate();
    this.valueLocal = this.value;

    if (this.markFormDirty == undefined) this.markFormDirtyLocal = true;
  },
  methods: {
    ...mapMutations("validation", [
      "addValidation",
      "removeValidation",
      "updateFormDirty",
    ]),
    ...mapMutations("generic", ["addFilter", "removeTag", "addEvent"]),
    validate() {
      this.notifications = [];

      if (this.required && this.valueLocal.length == 0) {
        var message = `${this.title} não pode ser vazio!`;
        this.notifications.push(message);
      }
    },
    executeConfirm() {
      if (this.range) {
        if (this.fieldTarget) {
          let obj = {
            fieldTarget: this.fieldTarget,
            value: { start: this.valueLocal[0], end: this.valueLocal[1] },
          };
          this.addFilter(obj);
        }
      }
    },
    close() {
      this.removeTag("period");
      this.addEvent({ name: "tagRemoved", data: "period" });
    },
  },
  computed: {
    ...mapState("validation", ["resetForm", "validations"]),
    ...mapGetters("generic", ["event"]),
  },
  watch: {
    valueLocal() {
      this.validate();
      this.formDirty = true;
      if (this.markFormDirtyLocal) this.updateFormDirty(true);
      this.$emit("input", this.valueLocal);
    },
    value() {
      this.valueLocal = this.value;
      if (this.markFormDirty) this.updateFormDirty(true);
    },
    notifications() {
      let self = this;
      this.notifications.forEach(function (notification) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
          notification: notification,
        };
        self.addValidation(obj);
      });

      if (this.notifications.length == 0) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
        };
        self.removeValidation(obj);
      }
    },
    resetForm: {
      handler(form) {
        if (form.name == this.formName) this.formDirty = false;
      },
      deep: true,
    },
    event: {
      handler(event) {
        if (event.name == "tagRemoved") {
          this.valueLocal = [];

        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #0a0a0a;
  letter-spacing: 0.5px !important;
}

.success {
  color: #94aa2a;
  font-size: 14px;
}

.invalid {
  color: #f0134d;
  font-size: 14px;
}
</style>
